import { z } from 'zod';

export const zodCompanyAdminEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.uuid(),
]);
